<nz-upload class="avatar-uploader" [nzMultiple]="false" nzName="file" [nzAccept]="accept"
  [nzListType]="type==0?'picture-card':'text'" [nzBeforeUpload]="beforeUpload" [nzTransformFile]="transformFile"
  [nzData]="getExtraData" [nzFileList]="fileList" [nzCustomRequest]="nzCustomRequest" [nzRemove]="onRemove"
  nzAction="{{uploadUrl}}" (nzChange)="handleChange($event)" [nzShowUploadList]="showList" [nzLimit]="1"
  [nzDownload]='DownloadFile' [nzPreview]='PreviewFile' [nzFileListRender]="type==0?fileListTpl:null">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="0">
      <img *ngIf="defaultSrc&&!showList" [src]="defaultSrc|src" style="width: 100%" />
      <ng-container *ngIf="showList||!defaultSrc">
        <i nz-icon nzType="plus"></i>
        <div class="ant-upload-text">上传</div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="1">
      <button nz-button class="button_view">
        <i nz-icon nzType="upload"></i>
        <span>{{"更换头像"|translate}}</span>
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <button nz-button (click)="fileselectClick($event)"><i nz-icon nzType="upload"></i>上传</button>
      <div *ngIf="type==2&&!showList"><span><i nz-icon nzType="file-done" nzTheme="outline"></i></span><a target="blank"  (click)="openLink($event)" href="{{defaultSrc|src}}">{{getFileName(defaultSrc)}}</a></div>
    </ng-container>
  </ng-container>
  <ng-template #fileListTpl let-list>
    <nz-image-group>
    <div *ngFor="let item of fileList" class="list-item">
      <img nz-image nzSrc="{{item.url|src}}" style="width: 100%;height: 100%;">
      <i nz-icon nzType="close" nzTheme="outline" (click)="deleteItem(item)" class="delete"></i>
    </div>
    </nz-image-group>
  </ng-template>
 
</nz-upload>